import {createTheme} from "@material-ui/core/styles";

export const ColorTheme = createTheme({
    palette: {
        secondary: {
            main: "#D6001C"
        }
    }
});
